import type { EventObject } from '~/models/tracking/Events.model';

type AnalyticsEventsState = {
  eventsToPushToDatalayer: {
    isPushedToDatalayer: boolean;
    eventObject: EventObject;
  }[];
};

export const useAnalyticsEventsStore = defineStore('myAnalyticsEventsStore', {
  state: (): AnalyticsEventsState => ({
    eventsToPushToDatalayer: [],
  }),
  actions: {
    pushEvent(eventObject: EventObject): void {
      const newArray = this.eventsToPushToDatalayer.slice();

      newArray.push({
        isPushedToDatalayer: false,
        eventObject,
      });

      this.eventsToPushToDatalayer = newArray;
    },
  },
});
